import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

/**
 * Generated with generate-feature-flag-custom-hook.sh script
 * on 2026-07-08T15:45:46+0000.
 */
export function useReservationMonthlyCalendarViewEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.EnableReservationMonthlyCalendarView,
    false
  );

  return Boolean(isEnabled);
}
